document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.whats-inside');

  const animateIn = element => {
    element.classList.remove('lg:tw-opacity-0', 'lg:tw-translate-y-[30px]');
    element.classList.add('lg:tw-opacity-100', 'tw-translate-y-0');
  };

  (function animateTitleOnScroll() {
    const title = root.querySelector('.title');

    const observerWhatsInsideSection = new IntersectionObserver(
      (entries, obs) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            animateIn(title);

            obs.unobserve(e.target);
          }
        }
      },
      { threshold: 0.3 }
    );

    observerWhatsInsideSection.observe(root);
  })();

  const mql = window.matchMedia('(min-width: 1024px)');
  const desktop = root.querySelector('.whats-inside__wrap');
  const total = Number(desktop?.dataset.totalCards || 0);
  const per = Number(desktop?.dataset.cardsPerSlide || 6);
  const counterCurrent = root.querySelector('.whats-inside__counter-current');

  let slider = null;

  const setCounter = sw => {
    if (!counterCurrent) return;
    const shown = Math.min((sw.activeIndex + 1) * per, total);
    counterCurrent.textContent = shown;
  };

  const init = () => {
    slider = new Swiper('.whats-inside .swiper', {
      slidesPerView: 1,
      spaceBetween: 48,
      speed: 1000,

      navigation: {
        nextEl: root.querySelector('.next'),
        prevEl: root.querySelector('.prev')
      },
      on: {
        init: setCounter,
        slideChange: setCounter
      }
    });
  };

  const destroy = () => {
    if (slider) {
      slider.destroy(true, true);
      slider = null;
    }
  };

  const sync = () => {
    if (mql.matches) {
      init();
    } else {
      destroy();
    }
  };

  sync();
  mql.addEventListener('change', sync);
});
